import React, { useEffect, useState } from 'react'
import { getAccOff, getListAccName } from '../Axios/searchoff';
import { ToastContainer } from "react-toastify";
import { toast } from 'react-toastify';
import InputMask from 'react-input-mask';
// import axios from 'axios';
import dayjs from 'dayjs';
import { AxiosInstanceSearch } from "../Axios/axios";

const stepData = [
  { step : 1, 
    content: 'Перевірте автоматичні вимикачі біля Вашого електролічильника. Автомати вимкнуті — положення вниз, ввімкнуті — вверх.', 
    img: '/img/send-off/step1.png', 
    variant1: 'Автомат включений', 
    variant2: 'Автомат виключений',
    endTitle: 'Проблема в електромережі помешкання',
    endImg: '/img/send-off/problem_in.png',
    endContent: 'Автоматичний вимикач спрацьовує через неполадки в електромережі помешкання. Зверніться до приватного електрика для обстеження Вашої мережі.'
  },

  { step : 2,
    content: 'Дізнайтесь, чи є електроенергія у Ваших сусідів.', 
    img: '/img/send-off/step2.png',
    variant1: 'Світла немає', 
    variant2: 'Світло є',
    endTitle: 'Проблема у внутрішньобудинковій електромережі',
    endImg: '/img/send-off/problem_in2.png',
    endContent: 'Якщо світла немає тільки у Вашій квартирі багатоквартирного будинку, проблема у внутрішньобудинковій електромережі. Зверніться до організації, яка обслуговує Ваше помешкання (ОСББ, ЛКП, ЖЕК).'
  },
]

const noValidInit = {
  img: '/img/send-off/send_off_alert.png', 
  title: '', 
  content: '', 
  show: false
}

const SendOff = () => {
  const[step, setStep] = useState(1);
  const[end, setEnd] = useState(false);
  const[pibData, setPibData] = useState({pib: '', rahynok: '' });
  const[noValidStep, setNoValidStep] = useState(noValidInit)

  useEffect(()=>{
      window.scrollTo(0,0);
  });

  const filteredData = stepData.filter(data=>{
    return data.step === step;
  })

  // function showOffAlert(data){
  //   if (data.switch_sub_reason > 0) {
  //     switch (data.switch_sub_reason) {
  //       case 1:
  //         return `За вказаною Вами адресою відсутня електроенергія до <b>${data.date_plan_in}</b> через <b>Графік аварійних відключень</b>. Просимо вибачення за тимчасові незручності.`
  //       case 2:
  //         return `За вказаною Вами адресою відсутня електроенергія до <b>${data.date_plan_in}</b> через <b>Графік погодинних відключень</b>. Просимо вибачення за тимчасові незручності.`
  //       case 3:
  //         return `За вказаною Вами адресою відсутня електроенергія до <b>${data.date_plan_in}</b> через <b>Спеціальний графік аварійних відключень</b>. Просимо вибачення за тимчасові незручності.`
  //       default:
  //         return 'За вказаною Вами адресою відсутня електроенергія. Просимо вибачення за тимчасові незручності.'
  //     }
  //   }
  //   else {
  //     switch (data.type_off) {
  //       case 0:
  //         return `За вказаною Вами адресою відсутня електроенергія до <b>${data.date_plan_in}</b> через <b>планові ремонтні роботи</b>. Просимо вибачення за тимчасові незручності.`
  //       case 1:
  //         return `За вказаною Вами адресою відсутня електроенергія до <b>${data.date_plan_in}</b> через <b>аварійне вимкнення</b>. Просимо вибачення за тимчасові незручності.`
  //       case 2:
  //         return `За вказаною Вами адресою відсутня електроенергія до <b>${data.date_plan_in}</b> через <b>оперативні перемикання</b>. Просимо вибачення за тимчасові незручності.`
  //       case 30:
  //         return `За Вашою адресою зафіксоване відключення електроенергії за борг, недопуск працівників до електролічильника або з інших причин.</br>Детальніша інформація за телефоном: <a href="tel:0800301568">0800301568</a>`
  //       default:
  //         return 'За вказаною Вами адресою відсутня електроенергія. Просимо вибачення за тимчасові незручності.'
  //     }
  //   }
  // }

  function sendData(e){
    e.preventDefault();
    const dataTimePhone = new FormData(e.target);
    const article = {
      light: 1,
      request_id: 'requests_site',
      pib: pibData.pib,
      rahynok: pibData.rahynok,
      phone: dataTimePhone.get('phone'),
      when_off: dayjs(dataTimePhone.get('timedate')).format('HH:mm DD.MM.YYYY'),
    }

    const config = {     
      headers: { 'content-type': 'application/json',}
    }

    AxiosInstanceSearch.post('/send_request_no_light', article, config).then(()=>{
      toast.success('Заявка відправлена в обробку', {
        position: toast.POSITION.BOTTOM_LEFT
     });
    }).catch(()=>{
      toast.error('Помилка відправки заявки', {
        position: toast.POSITION.BOTTOM_LEFT
     });
    })

    setStep(1);
  }

  function savePib(e){
    e.preventDefault();
    const dataPib = new FormData(e.target);
    const article = {
      pib: `${dataPib.get('surname')} ${dataPib.get('name')} ${dataPib.get('father')}`,
      rahynok: dataPib.get('acc')
    }

    // перевірка на співпадіння піб з ор
    getListAccName(article.rahynok, article.pib).then((resPib)=>{
      const data = resPib['hydra:member'];

      if(data.length > 0) {
        setPibData({...article});
        // перевірка на наявність звдання по ор
        if (!data[0].disconnectionTask) {
          // перевірка на наявність вимкнень по ор
          getAccOff(article.rahynok).then((resOff) => {
            if(!resOff.res) {
              setNoValidStep((validation) => ({
                ...validation,
                title: 'Помилка при обробці даних',
                content: '<p>Виникла помилка перевірки наявності "вимкнення". Просимо вибачення за тимчасові незручності. Спробуйте пізніше.</p>',
                show: true
              }))
            }
            else {
              resOff.dozvil 
              ? setStep(4)
              : setNoValidStep((validation) => ({
                ...validation,
                title: 'Відсутня електроенергія',
                content: `<p>Ви не можете подати заявку! Остання подана заявка була менше ніж 5 годин тому.</p>`,
                show: true
              }))
            } 
          }).catch(() => {
            setNoValidStep((validation) => ({
              ...validation,
              title: 'Помилка при обробці даних',
              content: '<p>Виникла помилка перевірки наявності "вимкнення". Просимо вибачення за тимчасові незручності. Спробуйте пізніше.</p>',
              show: true
            }))
          })
        }
        else {
          setNoValidStep((validation) => ({
            ...validation,
            title: 'Заплановане відключення',
            content: '<p>За вказаною Вами адресою передбачене відключення електроенергії за борг, недопуск працівників до електролічильника або з інших причин.</br>Детальніша інформація за телефоном: <a href="tel:0800301568">0800301568</a></p>',
            show: true
          }))
        }
      }
      else {
        setNoValidStep((validation) => ({
          ...validation,
          title: 'Дані не підтверджено',
          content: '<p>Введені Вами ПІБ та особовий рахунок не збігаються. Перевірте правильність внесеної інформації.</p>',
          show: true
        }))
      }
    }).catch(() => {
      setNoValidStep((validation) => ({
        ...validation,
        title: 'Помилка при обробці даних',
        content: '<p>Виникла помилка при перевірці валідності ПІБ. Просимо вибачення за тимчасові незручності. Спробуйте пізніше.</p>',
        show: true
      }))
    })
  }

  return (
    <div className="gpv-search off" data-aos="fade-up">
        <div className="container">
        <h1>Заявка про відсутність електропостачання</h1>
        {(!end && !noValidStep.show) ? <>
            {filteredData.map(stepdata=>{
                return <div key={stepdata.step} className="gpv-search-inner">
                        <img src={stepdata.img} width={500} height={500} alt="" />
                        <h5>Крок {stepdata.step}</h5>
                        <p>{stepdata.content}</p>
                        <div className="off-button-inner">
                            <button onClick={()=>{setStep(stepdata.step + 1)}}>{stepdata.variant1}</button>
                            <button onClick={()=>{setEnd(true)}}>{stepdata.variant2}</button>
                        </div>
                </div>
            })}</> 
        : <>
            {filteredData.map(stepdata=>{
                return <div key={stepdata.step} className="gpv-search-inner">
                        <img src={stepdata.endImg} width={500} height={500} alt="" />
                        <h5>{stepdata.endTitle}</h5>
                        <p>{stepdata.endContent}</p>
                        <div className="off-button-inner">
                          <button onClick={()=>{setStep(stepdata.step); setEnd(false)}}>Повернутися</button>
                        </div>
                </div>
            })}
          </>}

        {(step === 3 && !noValidStep.show) &&
          <div className="gpv-search-inner">
            <h5 className='form-title'>Введіть ПІБ власника особового рахунку та номер особового рахунку</h5>
            <form action="post" onSubmit={savePib}>
                <label htmlFor="surname">Прізвище*</label>
                <input className="input-search" id='surname' name='surname' type="text" required />
                <label htmlFor="name">Ім’я*</label>
                <input className="input-search" id='name' name='name' type="text" required/>
                <label htmlFor="father">По батькові*</label>
                <input className="input-search" id= 'father' name='father' type="text" required/>
                <label htmlFor="acc">Особовий рахунок*</label>
                <input className="input-search" id= 'acc' name='acc' type="number" required/>
                <button className="power-btn">Надіслати</button>
            </form>
          </div>}

          {(step === 4 && !noValidStep.show) &&
          <div className="gpv-search-inner">
            <img src={'/img/send-off/step4.png'} width={500} height={500} alt="" />
            <h5 className='form-title'>Відколи у Вас немає світла (час і дата)?</h5>
            <form action="post" onSubmit={sendData}>
                <label htmlFor="timedate">Оберіть Дату та час**</label>
                <input className="input-search" id='timedate' name='timedate' type="datetime-local" required />
                <label htmlFor="phone">Телефон*</label>
                <InputMask 
                  mask='(+380) 999 999 999' 
                  id='phone'
                  name='phone'
                  placeholder='(+380) 999 999 999'
                  className="input-search"
                  required
                >
                </InputMask>
                <button className="power-btn">Надіслати</button>
            </form>
          </div>}

          {noValidStep.show && 
            <div className="gpv-search-inner alert">
                <img src={noValidStep.img} width={500} height={500} alt="no-valid"/>
                <h5>{noValidStep.title}</h5>
                <div dangerouslySetInnerHTML={{ __html: noValidStep.content }} />
                <div className="off-button-inner">
                  <button onClick={()=>{setStep(3); setNoValidStep(noValidInit)}}>Повернутися</button>
                </div>
            </div>}
          <ToastContainer/>
        </div>
    </div>
  )
}

export default SendOff